<template>
  <div class="site-header-wrapper">
    <header class="site-header">
      <div class="site-logo">{{ siteTitle }}</div>
      <nav class="main-nav">
        <span v-for="item in normalizedNavItems" :key="item.label" class="main-nav-item">
          <router-link v-if="item.route" :to="item.route">{{ item.label }}</router-link>
          <span v-else>{{ item.label }}</span>
        </span>
      </nav>
      <div class="search-panel">
        <div class="search-bar">
          <input
            type="text"
            class="search-input"
            :placeholder="searchPlaceholder"
            aria-label="站内搜索"
          />
          <img :src="images.searchIcon" alt="搜索" />
        </div>
      </div>
      <button
        class="mobile-menu-toggle"
        :class="{ 'mobile-menu-toggle--open': isMobileMenuOpen }"
        type="button"
        @click="toggleMobileMenu"
        :aria-label="isMobileMenuOpen ? '关闭菜单' : '展开菜单'"
        :aria-expanded="isMobileMenuOpen.toString()"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </header>

    <div
      class="mobile-menu-mask"
      :class="{ 'mobile-menu-mask--visible': isMobileMenuOpen }"
      @click="closeMobileMenu"
    ></div>

    <section
      ref="mobilePanel"
      class="mobile-menu-panel"
      :class="{ 'mobile-menu-panel--open': isMobileMenuOpen }"
      :style="mobileMenuStyle"
    >
      <div class="mobile-menu__header">
        <div class="mobile-menu__title">{{ siteTitle }}</div>
        <button class="mobile-menu__close" type="button" @click="closeMobileMenu" aria-label="关闭菜单">×</button>
      </div>
      <div class="mobile-menu__search">
        <input type="text" :placeholder="searchPlaceholder" aria-label="站内搜索" />
        <button type="button" aria-label="执行搜索">
          <img :src="images.searchIcon" alt="" />
        </button>
      </div>
      <nav class="mobile-menu__nav">
        <button
          v-for="item in normalizedNavItems"
          :key="`mobile-${item.label}`"
          type="button"
          class="mobile-menu__nav-item"
          @click="handleMobileNavClick(item)"
        >
          <span>{{ item.label }}</span>
          <img :src="images.arrowIcon" alt="" />
        </button>
      </nav>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    siteTitle: {
      type: String,
      default: '新闻所历史（暂定）'
    },
    navItems: {
      type: Array,
      default: () => [
        { label: '领导关怀', route: '/lanhu_jigouyulishi' },
        { label: '建制沿革' },
        { label: '学科建设', route: '/lanhu_xuekeyukeyan' },
        { label: '创新工程' },
        { label: '传播平台' }
      ]
    },
    searchPlaceholder: {
      type: String,
      default: '搜索...'
    }
  },
  data() {
    return {
      isMobileMenuOpen: false,
      menuOrigin: { x: 95, y: 8 },
      images: {
        searchIcon: require('@/views/lanhu_shouye/assets/img/SketchPng48d84935d5a015c26c4b72f169e3d80d468628f4f9241b15f60cd40c9d2d3759.png'),
        arrowIcon: require('@/views/lanhu_shouye/assets/img/SketchPng72895929e9819fcf2124c82845d59a576118c9b4c94b94e6940eb31665ba5704.png')
      }
    };
  },
  computed: {
    normalizedNavItems() {
      const routeMap = {
        领导关怀: '/lanhu_jigouyulishi',
        学科建设: '/lanhu_xuekeyukeyan'
      };
      return this.navItems.map((item) => {
        if (item && typeof item === 'object' && 'label' in item) {
          if (!item.route && routeMap[item.label]) {
            return { ...item, route: routeMap[item.label] };
          }
          return item;
        }
        if (routeMap[item]) {
          return { label: item, route: routeMap[item] };
        }
        return { label: item };
      });
    },
    mobileMenuStyle() {
      const { x, y } = this.menuOrigin || { x: 95, y: 8 };
      return {
        '--menu-origin-x': `${x}%`,
        '--menu-origin-y': `${y}%`
      };
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  methods: {
    toggleMobileMenu(event) {
      const willOpen = !this.isMobileMenuOpen;
      if (willOpen) {
        this.captureMenuOrigin(event);
        this.isMobileMenuOpen = true;
      } else {
        this.closeMobileMenu();
      }
    },
    handleMobileNavClick(item) {
      if (!item || !item.route) {
        return;
      }
      this.$router.push(item.route);
      this.closeMobileMenu();
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
    captureMenuOrigin(event) {
      if (!event || typeof window === 'undefined') {
        return;
      }
      const panel = this.$refs.mobilePanel;
      const viewportWidth = window.innerWidth || 1;
      const viewportHeight = window.innerHeight || 1;
      const panelWidth = panel ? panel.offsetWidth : Math.min(360, viewportWidth);
      const panelLeft = Math.max(0, viewportWidth - panelWidth);
      const xPercent = ((event.clientX - panelLeft) / panelWidth) * 100;
      const yPercent = (event.clientY / viewportHeight) * 100;
      this.menuOrigin = {
        x: Math.min(100, Math.max(0, Number.isFinite(xPercent) ? xPercent : 95)),
        y: Math.min(100, Math.max(0, Number.isFinite(yPercent) ? yPercent : 8))
      };
    },
    handleResize() {
      if (typeof window === 'undefined') {
        return;
      }
      if (window.innerWidth > 1024 && this.isMobileMenuOpen) {
        this.closeMobileMenu();
      }
    }
  }
};
</script>

<style scoped>
.site-header-wrapper {
  position: relative;
}

.site-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  background-color: #9c1e23;
  padding: 36px clamp(40px, 8vw, 120px) 34px;
  color: #fff;
  column-gap: 40px;
  position: relative;
  overflow: hidden;
}

.site-header::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: clamp(30px, 6vw, 120px);
  height: 100%;
  aspect-ratio: 307 / 122;
  width: auto;
  min-width: 360px;
  max-width: 720px;
  background: url('~@/views/lanhu_shouye/assets/img/SketchPng7a3e25de6431990d079ffcde2fe49e63178d6b3d3c219dbf4a6416bd92f4676f.png')
    no-repeat right center / auto 100%;
  opacity: 0.6;
  pointer-events: none;
  z-index: 0;
}

.site-header > * {
  position: relative;
  z-index: 1;
}

.site-logo {
  font-size: 34px;
  font-family: 'SourceHanSerifCN-SemiBold', 'STSongti-SC-Bold', serif;
  letter-spacing: 0.45px;
  white-space: nowrap;
}

.main-nav {
  display: flex;
  gap: 32px;
  font-size: 20px;
  font-family: 'STSongti-SC-Bold', 'SourceHanSerifCN-SemiBold', serif;
  align-items: center;
  white-space: nowrap;
  justify-self: end;
  align-self: flex-end;
  padding-bottom: 2px;
  position: relative;
  z-index: 2;
}

.main-nav span {
  white-space: nowrap;
}

.main-nav a {
  color: inherit;
  text-decoration: none;
}

.search-panel {
  position: absolute;
  top: 30px;
  right: clamp(20px, 8vw, 140px);
  width: clamp(220px, 26vw, 320px);
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 30px;
  box-sizing: border-box;
  align-items: flex-end;
  pointer-events: auto;
  z-index: 1;
}

.search-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(253, 200, 200, 0.95);
  border-radius: 28px;
  border: 1px solid rgba(212, 137, 90, 0.85);
  color: #593629;
  font-size: 16px;
  padding: 4px 70px 4px 14px;
  width: 220px;
  box-shadow: none;
  position: relative;
  overflow: hidden;
  margin-top: -20px;
}

.search-bar::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 43px;
  background-color: #8b1e24;
  z-index: 0;
}

.search-bar::before {
  content: '';
  position: absolute;
  right: 12px;
  top: 50%;
  width: 18px;
  height: 18px;
  background: url('~@/views/lanhu_shouye/assets/img/SketchPng48d84935d5a015c26c4b72f169e3d80d468628f4f9241b15f60cd40c9d2d3759.png')
    no-repeat center / contain;
  transform: translateY(-50%);
  z-index: 1;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  color: #3f2d22;
  font-size: 16px;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  position: relative;
  z-index: 1;
}

.search-input::placeholder {
  color: rgba(63, 45, 34, 0.65);
}

.search-input:focus {
  outline: none;
}

.search-bar img {
  display: none;
}

.mobile-menu-toggle {
  display: none;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: transparent;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-direction: column;
  padding: 6px 8px;
  cursor: pointer;
  color: #fff;
  transition: background-color 0.3s ease;
}

.mobile-menu-toggle span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: currentColor;
  border-radius: 1px;
  transition: transform 0.35s cubic-bezier(0.4, 0.14, 0.3, 1.4), opacity 0.2s ease;
  transform-origin: center;
}

.mobile-menu-toggle--open {
  background: rgba(255, 255, 255, 0.18);
}

.mobile-menu-toggle--open span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.mobile-menu-toggle--open span:nth-child(2) {
  opacity: 0;
  transform: scaleX(0.3);
}

.mobile-menu-toggle--open span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

.mobile-menu-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity 0.3s ease, backdrop-filter 0.35s ease;
  pointer-events: none;
  z-index: 1000;
  backdrop-filter: blur(0px);
}

.mobile-menu-mask--visible {
  opacity: 1;
  pointer-events: auto;
  backdrop-filter: blur(6px);
}

.mobile-menu-panel {
  --menu-origin-x: 95%;
  --menu-origin-y: 8%;
  position: fixed;
  inset: 0 0 0 auto;
  width: 86vw;
  max-width: 360px;
  background: rgba(156, 30, 35, 0.98);
  backdrop-filter: blur(18px);
  padding: 32px 28px 48px;
  box-sizing: border-box;
  color: #fff;
  z-index: 1100;
  transform: translate3d(110%, 0, 0) scale(0.92);
  opacity: 0;
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.35s ease,
    box-shadow 0.3s ease, clip-path 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
  gap: 24px;
  pointer-events: none;
  overflow: hidden;
  transform-origin: var(--menu-origin-x) var(--menu-origin-y);
  clip-path: circle(0% at var(--menu-origin-x) var(--menu-origin-y));
  will-change: transform, opacity, clip-path;
}

.mobile-menu-panel::before {
  content: '';
  position: absolute;
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.25), transparent 70%);
  opacity: 0;
  transition: opacity 0.6s ease, transform 0.6s ease;
  pointer-events: none;
  top: var(--menu-origin-y);
  left: var(--menu-origin-x);
  transform: translate(-50%, -50%) scale(0.6);
}

.mobile-menu-panel--open {
  transform: translate3d(0, 0, 0) scale(1);
  pointer-events: auto;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.35);
  opacity: 1;
  animation: menuPanelIn 0.65s cubic-bezier(0.16, 1, 0.3, 1) both;
  clip-path: circle(160% at var(--menu-origin-x) var(--menu-origin-y));
}

.mobile-menu-panel--open::before {
  opacity: 0.4;
  transform: translate(-50%, -50%) scale(1.15);
}

.mobile-menu__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-menu__title {
  font-size: 22px;
  font-family: 'SourceHanSerifCN-SemiBold', serif;
}

.mobile-menu__close {
  background: transparent;
  border: none;
  color: #fde0d9;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
}

.mobile-menu__search {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(253, 200, 200, 0.35);
  border-radius: 999px;
  padding: 8px 16px;
}

.mobile-menu__search input {
  flex: 1;
  border: none;
  background: transparent;
  color: #fff5f2;
  font-size: 15px;
}

.mobile-menu__search input::placeholder {
  color: rgba(255, 255, 255, 0.8);
}

.mobile-menu__search input:focus {
  outline: none;
}

.mobile-menu__search button {
  background: #c24c4c;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-menu__search img {
  width: 16px;
  height: 16px;
}

.mobile-menu__nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mobile-menu__nav-item {
  width: 100%;
  border: none;
  background: rgba(255, 255, 255, 0.06);
  color: #fff8f1;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 12px;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'STSongti-SC-Bold', serif;
  opacity: 0;
  transform: translate3d(48px, 12px, 0) scale(0.92);
  filter: blur(8px);
  will-change: transform, opacity, filter;
  transition: opacity 0.25s ease, transform 0.25s ease, filter 0.25s ease;
}

.mobile-menu__nav-item img {
  width: 14px;
  height: 14px;
}

.mobile-menu-panel--open .mobile-menu__nav-item {
  animation: menuItemIn 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(1) {
  animation-delay: 0.05s;
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(2) {
  animation-delay: 0.1s;
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(3) {
  animation-delay: 0.15s;
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(4) {
  animation-delay: 0.2s;
}

.mobile-menu-panel--open .mobile-menu__nav-item:nth-child(5) {
  animation-delay: 0.25s;
}

@keyframes menuPanelIn {
  0% {
    transform: translate3d(110%, 10px, 0) scale(0.9);
    opacity: 0;
  }
  60% {
    transform: translate3d(-6px, -4px, 0) scale(1.02);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 1;
  }
}

@keyframes menuItemIn {
  0% {
    opacity: 0;
    transform: translate3d(60px, 18px, 0) scale(0.88);
    filter: blur(12px);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
    filter: blur(0px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobile-menu-panel,
  .mobile-menu-mask,
  .mobile-menu__nav-item {
    transition: none !important;
    animation: none !important;
    clip-path: none !important;
    filter: none !important;
  }
}

@media (min-width: 641px) {
  .site-header {
    width: 100vw;
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
  }
}

@media (max-width: 1024px) {
  .site-header {
    grid-template-columns: 1fr auto;
    text-align: left;
    padding: 20px 24px;
    row-gap: 0;
  }
  .main-nav {
    display: none;
  }
  .search-panel {
    display: none;
  }
  .mobile-menu-toggle {
    display: inline-flex;
    justify-self: end;
    border: none;
    background: rgba(255, 255, 255, 0.08);
    padding: 6px 10px;
    border-radius: 6px;
    box-shadow: none;
  }
}

@media (max-width: 640px) {
  .site-header {
    padding: 20px 12px;
    grid-template-columns: 1fr auto;
  }
  .site-logo {
    font-size: 26px;
  }
  .mobile-menu-toggle {
    width: 40px;
    height: 40px;
    padding: 6px;
  }
  .mobile-menu-panel {
    width: 100vw;
    max-width: none;
  }
}
</style>
